import { forwardRef } from 'react';
import type { ButtonHTMLAttributes, HTMLAttributes, ReactNode } from 'react';
import './primitives.css';

export interface MenuProps extends HTMLAttributes<HTMLDivElement> {}

export function Menu({ className, children, ...rest }: MenuProps) {
  return (
    <div role="menu" className={['lm-menu', className].filter(Boolean).join(' ')} {...rest}>
      {children}
    </div>
  );
}

export interface MenuItemProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  icon?: ReactNode;
  intent?: 'default' | 'danger';
  trailing?: ReactNode;
}

export const MenuItem = forwardRef<HTMLButtonElement, MenuItemProps>(function MenuItem(
  { icon, intent = 'default', trailing, className, children, type = 'button', ...rest },
  ref,
) {
  const classes = [
    'lm-menu-item',
    intent === 'danger' ? 'lm-menu-item--danger' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');
  return (
    <button ref={ref} role="menuitem" type={type} className={classes} {...rest}>
      {icon}
      <span style={{ flex: 1 }}>{children}</span>
      {trailing}
    </button>
  );
});

export function MenuDivider() {
  return <div className="lm-menu__divider" role="separator" />;
}

export function MenuLabel({ children }: { children: ReactNode }) {
  return <div className="lm-menu__label">{children}</div>;
}
